module.exports = __webpack_public_path__ + "img/icon-wallet-name-red-16h-proximax-sirius-faucet.df9958eb.svg";